__turbopack_context__.v({
  "arrow": "KUG2vq_arrow",
  "badge": "KUG2vq_badge",
  "badgeFilled": "KUG2vq_badgeFilled",
  "badgeLabel": "KUG2vq_badgeLabel",
  "badgeLg": "KUG2vq_badgeLg",
  "badgeLight": "KUG2vq_badgeLight",
  "badgeOutline": "KUG2vq_badgeOutline",
  "badgeRadiusXl": "KUG2vq_badgeRadiusXl",
  "badgeSection": "KUG2vq_badgeSection",
  "badgeSm": "KUG2vq_badgeSm",
  "badgeWithLeft": "KUG2vq_badgeWithLeft",
  "blue": "KUG2vq_blue",
  "bubble": "KUG2vq_bubble",
  "code": "KUG2vq_code",
  "codeBlue": "KUG2vq_codeBlue",
  "cyan": "KUG2vq_cyan",
  "dimmed": "KUG2vq_dimmed",
  "gray": "KUG2vq_gray",
  "green": "KUG2vq_green",
  "teal": "KUG2vq_teal",
  "text": "KUG2vq_text",
  "textSm": "KUG2vq_textSm",
  "textXs": "KUG2vq_textXs",
  "title": "KUG2vq_title",
  "tooltip": "KUG2vq_tooltip",
  "violet": "KUG2vq_violet",
  "yellow": "KUG2vq_yellow",
});
